<template>
    <div class="bg-white">
        <div class="py-2 d-flex">
                <!-- Sperre oder Freigabe-->
                <b-button class="mr-auto ml-2 my-auto"
                    @click="blackOrWhite = !blackOrWhite"
                    variant="outline-secondary"
                >
                    <span v-if="blackOrWhite" class="text-danger">Sperrung</span>
                    <span v-else class="text-success">Freigabe</span>
                </b-button>
                <h1 class="mr-auto">Massensperrung</h1>
        </div>
        <div class="mt-4 justify-content-between">
            <b-row>
                <!--Das Textfeld in dem die ASINs eingetragen werden sollen.-->
                <div class="text-center  col-5">
                    <h5>Kopierfeld</h5>
                    <small v-if="foundCountry !== ''">Es wurde "{{foundCountry}}" als Land erkannt</small>
                    <textarea @blur="processesAsinTextArea" size="lg" class="m-2 w-100" rows="20" placeholder="Hier text einfügen" 
                    v-model="asinTextArea" style="background-color: #F9f9f9;">
                    </textarea>    
                </div>            
                <!--Das Textfeld in dem die ASINs eingetragen werden sollen.-->
                <div class="text-center col-2">
                    <h5>extrahierte ASINs</h5>
                    <small v-if="asins.length > 0">Es wurden {{asins.length}} ASINs erkannt</small>
                    <textarea @paste="TextAreaNextLine" @blur="processExtractedAsinsTextArea()" size="lg" class="w-100 m-2" rows="20" placeholder="" 
                    v-model="extractedAsinTextArea" style="background-color: #F9f9f9;">
                    </textarea>    
                </div>
                <div class="col-4 ml-auto">
                    <b-row><h5>Region</h5></b-row>
                    <!-- Hier werden alle Regionen aufgelistet-->
                        <b-row v-for="(regionsPart, idx) in chunkedRegions" :key="'r'+idx">
                            <b-col v-for="region in regionsPart" :key="region.id">
                                <div class="row justify-content-start">
                                    <b-form-checkbox
                                        v-model="region.selected"
                                        :name="`checkbox-region-${region.name}`"
                                    ><!-- checkbox -->
                                    {{region.name}}
                                    </b-form-checkbox>
                                </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3"><h5>Land</h5></b-row>
                    <!-- Hier werden alle Länder aufgelistet-->
                    <b-row v-for="(countryPart, idx) in chunkedCountries" :key="'l'+idx">
                        <b-col v-for="country in countryPart" :key="country.id">
                            <div class="row justify-content-start">
                                <b-form-checkbox
                                    v-model="country.selected"
                                    :name="`checkbox-country-${country.name}`"
                                >
                                {{country.name}}
                                </b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3"><h5>Markt</h5></b-row>
                    <!-- Hier werden alle Märkte aufgelistet-->
                    <b-row v-for="(marketPart, idx) in chunkedMarkets" :key="'m_'+idx">
                        <b-col v-for="market in marketPart" :key="market.id">
                            <div v-if="market" class="row justify-content-start">
                                <b-form-checkbox
                                    v-model="market.selected"
                                    :name="`checkbox-market-${market.identifier}`"
                                ><!-- checkbox -->
                                    {{market.name}}
                                </b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>              
                </div>
            </b-row>
        </div>
        <div class="w-75 mx-auto text-center">
            <div class="mt-3">
                <!-- Ein Dropdown für die Sperrgründe und optionale Beschreibung-->
                <b-form-select
                    size="sm" v-model="blockerReasonSelected"
                    :options="blockerReasons" value-field="value"
                    text-field="text" class="w-50"
                >
                        <b-form-select-option value="" disabled>-- Grund --</b-form-select-option>
                </b-form-select>
            </div>
            <!-- -->
            <div class="mx-auto mt-2 w-50" v-if="blockerReasonSelected.commentRequired">
                Beschreiben Sie kurz den Grund:
                <b-input v-model="blockerReasonSelected_userDescription"></b-input>
            </div>

            <b-btn class="mx-auto mt-2" variant="primary" @click="createMassblocker">Sperrungen erstellen</b-btn>
        </div>

        <b-Modal id="validationModal" v-model="validationModal.show" hide-footer hide-header>
            <div class="text-center">         
                <p>{{validationModal.text}}</p>
                <b-button @click="validationModal.show = false">Ok</b-button>
            </div>
        </b-Modal>
        <b-modal id="processingModal" v-model="processingModal.show" 
        :title="processingModal.title" :ok-only="true" :noCloseOnBackdrop="true" >
            {{processingModal.text}}
            <div v-if="errorAsins.length > 0">
                <hr>
                Folgende Asins konnten nicht verarbeitet werden:<br>
                <span v-for="errorAsin in errorAsins" :key="errorAsin">
                    {{errorAsin}}<br>
                </span>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default{
    data(){
        return{
            user: null,
            blackOrWhite: true,
            asins: [],
            errorAsins: [],
            totalAsins: 0,
            asinTextArea: "",
            extractedAsinTextArea:"",
            foundCountry: "",
            compareArray: [], //used for processing with the extracted asins array
            regions:[],
            countries:[],
            markets:[],
            marketCountries: [], //separate from markets, bc map markets->countries is surjective.
            blockerReasonSelected: {
                reason: '',
                commentRequired: false
            },
            blockerReasonSelected_userDescription: "",
            blockerReasons:[],
            validationModal:{
                text: '',
                show: false
            },
            processingModal:{
                text: '',
                title: 'Verarbeitung',
                show: false,
            },
            altCountryNames: [
                { altName: "Australien",                   name: "Australia"},
                { altName: "Brasilien",                    name: "Brazil"},
                { altName: "Kanada",                       name: "Canada"},
                { altName: "Deutschland",                  name: "Germany"},
                { altName: "Spanien",                      name: "Spain"},
                { altName: "Frankreich",                   name: "France"},
                { altName: "Italien",                      name: "Italy"},
                { altName: "Japan",                        name: "Japan"},
                { altName: "Mexiko",                       name: "Mexico"},
                { altName: "Niederlande",                  name: "Netherlands"},
                { altName: "Polen",                        name: "Poland"},
                { altName: "Schweden",                     name: "Sweden"},
                { altName: "Singapur",                     name: "Singapore"},
                { altName: "Türkei",                       name: "Turkey"},
                { altName: "Großbritannien",               name: "Great Britain"},
                { altName: "USA",                          name: "U.S.A"},
                { altName: "Portugal",                     name: "Portugal"},
                { altName: "Vereinigte Arabische Emirate", name: "United Arab Emirates"}
            ]
        }
    },
    computed: {
	    chunkedRegions() {
		    return _.chunk(this.regions, 3);
	    },
	    chunkedCountries() {
		    return _.chunk(this.marketCountries, 3);
	    },
	    chunkedMarkets() {
		    return _.chunk(this.markets, 3);
	    }
		},
    methods: {
        processesAsinTextArea(){
            if(this.asinTextArea == null || this.asinTextArea === '') {this.foundCountry = ""; return}
            let preSelectedMarket = null;
            let tempAsins = [];
            let asinTextProcess = this.asinTextArea.split("\n");
            asinTextProcess = asinTextProcess.filter(e => e !== '')
            asinTextProcess.forEach(line => {
                if(preSelectedMarket === null){
                    this.marketCountries.forEach(country => {
                        if(line.includes('| ' + country.name)|| line.includes('| ' + country.altName)){
                            if(line.includes('| ' + country.name))      this.foundCountry = country.name;
                            if(line.includes('| ' + country.altName))   this.foundCountry = country.altName;

                            let changedMarkets = this.markets.filter(market => market.countryId === country.id && market.name.includes('Amazon'))
                                                        .map(market => {market.selected = true; return market});
                            this.markets.forEach(market => {
                                changedMarkets.forEach(cMarket =>{
                                    if(market.id === cMarket.id){
                                        market = cMarket;
                                        preSelectedMarket = market.name;
                                    }
                                })
                            })
                        }
                    })
                }
                if(line.includes('ASIN: ')){
                    let extracedAsin = line.match(/ASIN: (.{10})/);
                    if(extracedAsin){
                        tempAsins.push(extracedAsin[1])
                    }
                }
            })
            if(tempAsins.length !== this.asins.length){
                tempAsins.forEach(e => {
                    if(!this.asins.includes(e)){
                        this.asins.push(e);
                    }
                });
            };
            if(this.asins.length > 0){
                this.extractedAsinTextArea = this.asins.join('\n'); 
            } 
        },
        //for adding asins manually
        processExtractedAsinsTextArea(){
            if(this.extractedAsinTextArea === "" && this.asins.length === 0) return;

            this.compareArray = this.extractedAsinTextArea.split('\n')
                  .map( row => row.trim() ) //remove trailing whitespace
                  .filter( id => id ) // remove empty lines
            if(this.compareArray.length !== this.asins.length){
                this.compareArray.forEach(e => {
                    if(!this.asins.includes(e) && e.trim() !== "" && e.trim() !== "\n"){
                        this.asins.push(e);
                    }
                });
                this.asins.forEach(e => {
                    if(!this.compareArray.includes(e)){
                        this.asins = this.asins.filter(el => el !== e )
                    }
                })
            };
        },
        TextAreaNextLine(event){
            const textArea = event.target;
            let cursorPosition = textArea.selectionStart;
            let value = textArea.value;
            
            // Check if the cursor is at the end + textfield not empty + last symbol not newLine character
            if (cursorPosition === value.length && this.extractedAsinTextArea != "" &&
                this.extractedAsinTextArea.slice(-1) != '\n' ) {

                // Append a newline character and set the new textArea value
                textArea.value = `${value}\n`;
                this.extractedAsinTextArea = textArea.value;

                // Update the cursor position to the end of the new line
                Vue.nextTick(() => {
                textArea.selectionStart = cursorPosition + 1;
                textArea.selectionEnd = cursorPosition + 1;
                });
            } else {
                this.extractedAsinTextArea = value;
            }
        },

        // Validierung, ob das nötigste Eingegeben wurde(Asin,Checkbox,Sperrgrund, Sperrgrundbeschreibung)
        blockerValidation(){
            if(this.asins.length <= 0){
                this.validationModal.text = "Es müssen ein oder meherer ASINs hinzugefügt werden.",
                this.validationModal.show = true;
                return false;
            }else if(![...this.marketCountries, ...this.markets, ...this.regions].some( x => x.selected )){
                this.validationModal.text = "Es muss mindestens eine Auswahl in Region, Länder oder Märkte gemacht werden.",
                this.validationModal.show = true;
                return false;
            } else if (this.blockerReasonSelected.reason == ""){
                this.validationModal.text = "Es muss ein Sperrgrund ausgewählt werden.";
                this.validationModal.show = true;
                return false; 
            } else if(this.blockerReasonSelected.commentRequired == true
            && (this.blockerReasonSelected_userDescription == null 
            || this.blockerReasonSelected_userDescription == "")){
                this.validationModal.text = "Der Sperrgrund muss beschrieben werden.",
                this.validationModal.show = true;
                return false;
            } else {
                return true;
            }
        },
        createMassblocker(){
            this.processExtractedAsinsTextArea();
            if(!this.blockerValidation()){
                console.log('Validierung fehlgeschlagen');
                return;
            }
            this.processingModal.show = true;

            if(!this.blockerReasonSelected.commentRequired){
                this.blockerReasonSelected_userDescription = null;
            }

            let request = {
                asin : null,
                black_or_white : this.blackOrWhite,
                region_ids: this.regions         .filter( region => region.selected   ).map( r => r.id ),
                country_ids: this.marketCountries.filter( country => country.selected ).map( c => c.id ),
                market_ids: this.markets         .filter( market => market.selected   ).map( m => m.id ),
                reason: this.blockerReasonSelected.reason,
                reasonDescription: this.blockerReasonSelected_userDescription,
                username: this.user.name,
            }

            const totalAsins = this.asins.length
            // reset the text
            this.processingModal.title = 'Verarbeitung';
            this.processingModal.text = `Wird bearbeitet.`;
            this.errorAsins = [];

            this.makeRequest(this.asins,totalAsins,request)
            .catch(error => {
                console.log(error)
            })

        },
        makeRequest(asins,totalCount,request){
            return new Promise((resolve, reject)=>{
                request.asin = asins.pop();
                let tempAsin = request.asin;
                axios.post(`/mds/blocker_manual/bulk`, request).then( response => {
                    let percent = 100 * (1 - (asins.length / totalCount));
                    this.processingModal.text = ` verarbeite ASIN: ${request.asin} - ${totalCount - asins.length} von ${totalCount} (${percent.toFixed(2)}%).`;
                    if(asins.length <= 0)
                    {
                        this.processingModal.title = 'Verarbeitung - Abgeschlossen';
                        this.processingModal.text = 'Alle ASINs bearbeitet.';
                        this.resetFields();

                        resolve();
                    }
                    else
                    {
                        resolve(this.makeRequest(this.asins,totalCount,request));
                    }
                    // if no Asins change modal text - if Asins recursiv call
                }).catch( error => {
                    console.log(error);
                    this.errorAsins.push(tempAsin);

                    if(asins.length <= 0)
                    {
                        this.processingModal.title = 'Verarbeitung - Abgeschlossen';
                        this.processingModal.text = 'Alle ASINs bearbeitet.';
                        this.resetFields();

                        resolve()
                    }
                    else {
                        resolve(this.makeRequest(this.asins,totalCount,request));
                    }
                });

            });
        },

        // Zurücksetzen aller Felder für ggfs. weiter eingaben.
        resetFields() {
            this.asins = [];
            this.compareArray = [];
            this.asinTextArea = "";
            this.extractedAsinTextArea = "";
            this.foundCountry = "";
            this.marketCountries = this.marketCountries.map( x => { x.selected = false; return x });
            this.markets = this.markets.map( x => { x.selected = false; return x });
            this.regions = this.regions.map( x => { x.selected = false; return x });
        },        

    },
    mounted () {
        let promises = [
            ['country', 'market', 'region'].map( s => axios.get(`/mds/${s}`)),
            axios.get('/blocker_manual_reason/all'),
            axios.get('/user/self')
        ].flat();

        Promise.all(promises).then(([_countries, _markets, _regions, _blockerManualReasons, _user]) =>
        {
            this.countries = _countries.data;
            this.markets = _markets.data;
            this.regions = _regions.data;
            this.blockerReasons = _blockerManualReasons.data.map( x => { return { text: x.reason, value: x } });
            this.user = _user.data;
            for (let market of this.markets){
                let country = this.countries.find(country => country.id === market.countryId);
                country.selected = false;
                if( (market.identifier.substr(0, 4) === 'AMZ-') || RegExp("amazon", "i").test(market.name)){
                    country.isAmazonAccount = true;
                    market.isAmazonAccount = true;
                }
                else if( country.isAmazonAccount === undefined ){
                    country.isAmazonAccount = false;
                }

                let twin = this.marketCountries.find( other => other.id === country.id );
                if( twin ){
                    twin.isAmazonAccount = twin.isAmazonAccount || country.isAmazonAccount;
                }
                else{
                    this.marketCountries.push(_.cloneDeep(country));
                }
            }

            this.marketCountries = this.marketCountries.map(mCountry => {
                let temp = this.altCountryNames.find(acn => acn.name === mCountry.name);
                if(temp){
                    mCountry.altName = temp.altName;
                }
                return mCountry;
            })
        })
        .catch( error => console.log(error) );
    }
}
</script>